// extracted by mini-css-extract-plugin
export default {"root":"card-anomaly_root__Ysh2x","iconWrapper":"card-anomaly_iconWrapper__yFS7w","badge":"card-anomaly_badge__Z2js6","badge-section":"card-anomaly_badge-section__Z3+Ga"};